import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

import DropdownMenu from '../DropdownMenu';
import Avatar from '../Avatar';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

class Invitation extends React.Component {
    onAction = action => {
        const { onAction, invitation } = this.props;
        onAction(invitation, action);
    };

    render() {
        const { invitation, actions, classes } = this.props;
        return (
            <Paper square elevation={1} className={classes.item}>
                <Avatar>
                    <i className="material-icons">person</i>
                </Avatar>
                <div className={classes.info}>
                    <Typography>{invitation.invitedEmail}</Typography>
                    <Typography variant="caption">
                        Pending invitation...
                    </Typography>
                </div>
                <div className={classes.actionMenu}>
                    <DropdownMenu actions={actions} onClick={this.onAction} />
                </div>
            </Paper>
        );
    }
}

Invitation.propTypes = {
    invitation: PropTypes.object.isRequired,
    actions: PropTypes.array.isRequired,
    onAction: PropTypes.func.isRequired,
};

const style = ({ spacing }) => ({
    item: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingLeft: spacing.unit * 3,
    },
    info: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        flexGrow: 1,
        paddingLeft: spacing.unit * 2,
    },
    actionMenu: {
        display: 'flex',
        alignItems: 'center',
        marginRight: spacing.unit * 2,
    },
});

export default injectSheet(style)(Invitation);



// WEBPACK FOOTER //
// ./src/components/invitations/Invitation.js